import { useCreateUserBoardCardConfigMutation } from '../../__generated__/chirp/com/hubspot/crm/pipeline/board/configuration/rpc/CrmPipelineBoardConfigurationService.hooks';
import { useCreateAdminBoardCardConfigMutation } from '../../__generated__/chirp/com/hubspot/crm/pipeline/board/configuration/rpc/CrmPipelineBoardConfigurationService.hooks';
import * as Queries from '../../__generated__/chirp/com/hubspot/crm/pipeline/board/configuration/rpc/CrmPipelineBoardConfigurationService.dfc.new';
import { getJSONFormattedSectionSettings } from './utils';
import { useObjectTypeId } from 'crm-object-board-core/objectTypeDefinition';
import { useSelectedPipelineIdByAccess } from '../hooks/useSelectedPipelineIdByAccess';
import { useIsAdminView } from '../providers/settings/CardSettingsPanelProvider';
import { useCallback } from 'react';
import { useAppId } from '../hooks/useAppId';
const useSaveCardSections = () => {
  const isAdminView = useIsAdminView();
  const [saveAdminCardSectionSettings, {
    loading: adminLoading,
    error: adminError
  }] = useCreateAdminBoardCardConfigMutation({
    refetchQueries: [Queries.GET_ADMIN_BOARD_CARD_CONFIG_QUERY, Queries.GET_USER_BOARD_CARD_CONFIG_QUERY],
    update(cache, {
      data: responseData
    }, context) {
      // Update cache with new settings
      if (!responseData || !context.variables) {
        return;
      }
      const query = {
        query: Queries.GET_ADMIN_BOARD_CARD_CONFIG_QUERY,
        variables: {
          objectTypeId: context.variables.objectTypeId,
          pipelineId: context.variables.pipelineId,
          appId: context.variables.appId
        }
      };
      const existing = cache.readQuery(query);
      if (!existing) {
        return;
      }
      cache.writeQuery(Object.assign({}, query, {
        data: {
          result: Object.assign({}, existing.result, responseData.result)
        }
      }));
    }
  });
  const [saveUserCardSectionSettings, {
    loading: userLoading,
    error: userError
  }] = useCreateUserBoardCardConfigMutation({
    refetchQueries: [Queries.GET_USER_BOARD_CARD_CONFIG_QUERY],
    update(cache, {
      data: responseData
    }, context) {
      // Update cache with new settings
      if (!responseData || !context.variables) {
        return;
      }
      const query = {
        query: Queries.GET_USER_BOARD_CARD_CONFIG_QUERY,
        variables: {
          objectTypeId: context.variables.objectTypeId,
          pipelineId: context.variables.pipelineId,
          appId: context.variables.appId
        }
      };
      const existing = cache.readQuery(query);
      if (!existing) {
        return;
      }
      cache.writeQuery(Object.assign({}, query, {
        data: {
          result: Object.assign({}, existing.result, responseData.result)
        }
      }));
    }
  });
  return {
    saveCardSectionSettings: isAdminView ? saveAdminCardSectionSettings : saveUserCardSectionSettings,
    loading: isAdminView ? adminLoading : userLoading,
    error: isAdminView ? adminError : userError
  };
};

// Saves draft sections addition/removals/reorders
export const useSaveCardSectionSettings = () => {
  const pipelineId = useSelectedPipelineIdByAccess();
  const objectTypeId = useObjectTypeId();
  const appId = useAppId();
  const {
    saveCardSectionSettings,
    loading,
    error
  } = useSaveCardSections();
  const save = useCallback(({
    updatedSettings
  }) => {
    return saveCardSectionSettings({
      variables: {
        boardCardSectionConfigurations: getJSONFormattedSectionSettings(updatedSettings),
        objectTypeId,
        pipelineId,
        appId
      }
    });
  }, [saveCardSectionSettings, objectTypeId, pipelineId, appId]);
  return {
    saveCardSectionSettings: save,
    loading,
    error
  };
};